@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          @if (motivoNaoVenda == null) {
            <div class="titulo_texto">Novo Motivo (Não Venda)</div>
          }
          @if (motivoNaoVenda != null) {
            <div class="titulo_texto">Alterar Motivo (Não Venda)</div>
          }
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      <form [formGroup]="formDados" (ngSubmit)="salvar()">
        <div class="form-row">
          <div class="form-group col-sm-10">
            <label><b>Motivo:</b></label>
            <input class="form-control form-control-sm" type="text" name="motivo" [ngClass]="{ 'is-invalid': enviado && f.motivo.errors?.required }" formControlName="motivo" />
            @if (enviado && f.motivo.errors?.required) {
              <div class="erro pt-1">Motivo em branco!</div>
            }
          </div>
          <div class="form-group col-sm-2">
            <label><b>Visita Efetiva:</b></label>
            <br />
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="visita_efetiva" id="optVisitaEfetivaNao" value="0" (change)="selecionarVisitaEfetiva($event.target.value)" [checked]="visitaEfetivaSelecionada == '0'" />
              <label class="form-check-label" for="optVisitaEfetivaNao">Não</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="visita_efetiva" id="optVisitaEfetivaSim" value="1" (change)="selecionarVisitaEfetiva($event.target.value)" [checked]="visitaEfetivaSelecionada == '1'" />
              <label class="form-check-label" for="optVisitaEfetivaSim">Sim</label>
            </div>
          </div>
          @if (visitaEfetivaSelecionada == 0) {
            <div class="form-group col-sm-2">
              <label><b>Retornar em dias:</b></label>
              <input class="form-control form-control-sm" type="number" min="0" step="1" name="retornar_dias" [ngClass]="{ 'is-invalid': enviado && f.retornar_dias.errors?.invalid }" formControlName="retornar_dias" />
              @if (enviado && f.retornar_dias.errors?.invalid) {
                <div class="erro pt-1">Retornar em dias invÃ¡lido!</div>
              }
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
